/*
 * @Author: your name
 * @Date: 2021-03-16 09:17:53
 * @LastEditTime: 2021-03-30 17:05:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\SRM\router\modules\settled.js
 */
export default [{
    path: '/settle-list',
    component: resolve => require(['../../views/entry/index.vue'], resolve),
    meta: {
      title: '入驻列表'
    }
  },
  {
    path: '/read-only',
    component: resolve => require(['../../views/entry/readInfo.vue'], resolve),
    meta: {
      title: '查看详情'
    }
  },
  {
    path: '/sale-area',
    component: resolve => require(['../../views/entry/components/saleArea'], resolve),
    meta: {
      title: '区域设置'
    }
  },
  {
    path: '/editArea',
    component: resolve => require(['../../views/entry/components/editArea'], resolve),
    meta: {
      title: '区域编辑'
    }
  },
  {
    path: '/wepay',
    component: resolve => require(['../../views/settings/openWePay.vue'], resolve),
    meta: {
      title: '开通微信支付'
    }
  },
  // {
  //     path: '/settled',
  //     component: resolve => require(['../../views/settled/index'], resolve),
  //     meta: { title: '入驻' }
  // },
  // {s
  //     path: '/qualificationsInfo',
  //     component: resolve => require(['../../views/settled/qualificationsInfo'], resolve),
  //     meta: { title: '资质信息管理' }
  // },
  // {
  //     path: '/addQualifications',
  //     component: resolve => require(['../../views/settled/addQualifications'], resolve),
  //     meta: { title: '新增资质' }
  // },
  // {
  //     path: '/basicInfo',
  //     component: resolve => require(['../../views/settled/basicInfo'], resolve),
  //     meta: { title: '基础信息' }
  // },
  // {
  //     path: '/business',
  //     component: resolve => require(['../../views/settled/mainBusinessscope/business'], resolve),
  //     meta: { title: '主营业务范围及区域' }
  // },
  {
    path: '/customer',
    component: resolve => require(['../../views/customer/index.vue'], resolve),
    meta: {
      title: '客户管理'
    }
  },
  {
    path: '/customer/free-sale-management',
    component: resolve => require(['../../views/customer/free-sale-management'], resolve),
    meta: { title: '自由销售人管理' }
  },
  {
    path: '/customer/office-franchising-list',
    component: resolve => require(['../../views/customer/office-franchising-list'], resolve),
    meta: { title: '总部特许经营列表' }
  },  
  {
    path: '/supplier',
    component: resolve => require(['../../views/supplier/index.vue'], resolve),
    meta: {
      title: '销售端'
    }
  }
]



// WEBPACK FOOTER //
// ./src/SRM/router/modules/settled.js